import { DateTimeHelper } from '../../../../helpers/date-time.helper';
import { TransportModeHelper } from '../../../../helpers/transport-mode.helper';
import { TransportSubModeHelper } from '../../../../helpers/transport-sub-mode.helper';
import type { IConnectionLinkDetails } from '../../../../models/connection-link-details.model';
import type { IConnectionLink } from '../../../../models/connection-link.model';
import type { ICoordinate } from '../../../../models/coordinate.model';
import type { INote } from '../../../../models/note.model';
import { CallApiModel } from './call.api-model';

export class ConnectionLinkApiModel {
  private static parseDateTime(dateTimeString: string | undefined) {
    return dateTimeString ? DateTimeHelper.parse(dateTimeString) : undefined;
  }

  public static mapToBusinessModel(apiModel: ConnectionLinkApiModel): IConnectionLink {
    return {
      transportMode: TransportModeHelper.parse(apiModel.transportMode),
      transportSubMode: TransportSubModeHelper.parse(apiModel.transportSubMode),
      origin: CallApiModel.mapToBusinessModel(apiModel.origin),
      destination: CallApiModel.mapToBusinessModel(apiModel.destination),
      distanceInMeters: apiModel.distanceInMeters,
      estimatedNumberOfSteps: apiModel.estimatedNumberOfSteps,
      plannedDepartureTime: ConnectionLinkApiModel.parseDateTime(apiModel.plannedDepartureTime),
      plannedArrivalTime: ConnectionLinkApiModel.parseDateTime(apiModel.plannedArrivalTime),
      estimatedDepartureTime: ConnectionLinkApiModel.parseDateTime(apiModel.estimatedDepartureTime),
      estimatedArrivalTime: ConnectionLinkApiModel.parseDateTime(apiModel.estimatedArrivalTime),
      plannedDurationInMinutes: apiModel.plannedDurationInMinutes,
      estimatedDurationInMinutes: apiModel.estimatedDurationInMinutes,
      notes: apiModel.notes,
      journeyLegIndex: apiModel.journeyLegIndex,
    };
  }

  public static mapToBusinessDetailsModel(apiModel: ConnectionLinkApiModel): IConnectionLinkDetails {
    return {
      transportMode: TransportModeHelper.parse(apiModel.transportMode),
      transportSubMode: TransportSubModeHelper.parse(apiModel.transportSubMode),
      origin: CallApiModel.mapToBusinessModel(apiModel.origin),
      destination: CallApiModel.mapToBusinessModel(apiModel.destination),
      distanceInMeters: apiModel.distanceInMeters,
      estimatedNumberOfSteps: apiModel.estimatedNumberOfSteps,
      plannedDepartureTime: ConnectionLinkApiModel.parseDateTime(apiModel.plannedDepartureTime),
      plannedArrivalTime: ConnectionLinkApiModel.parseDateTime(apiModel.plannedArrivalTime),
      estimatedDepartureTime: ConnectionLinkApiModel.parseDateTime(apiModel.estimatedDepartureTime),
      estimatedArrivalTime: ConnectionLinkApiModel.parseDateTime(apiModel.estimatedArrivalTime),
      plannedDurationInMinutes: apiModel.plannedDurationInMinutes,
      estimatedDurationInMinutes: apiModel.estimatedDurationInMinutes,
      notes: apiModel.notes,
      journeyLegIndex: apiModel.journeyLegIndex,
      linkCoordinates: apiModel.linkCoordinates,
    };
  }

  transportMode!: string;
  transportSubMode!: string;
  origin!: CallApiModel;
  destination!: CallApiModel;
  distanceInMeters?: number;
  estimatedNumberOfSteps?: number;
  plannedDepartureTime?: string;
  plannedArrivalTime?: string;
  estimatedDepartureTime?: string;
  estimatedArrivalTime?: string;
  plannedDurationInMinutes?: number;
  estimatedDurationInMinutes?: number;
  notes?: INote[];
  journeyLegIndex!: number;
  linkCoordinates?: ICoordinate[];
}
